// components/Experience.js
import React from 'react';

const Experience = () => {
  return (
    <section id="experience" className="p-8 lg:w-full bg-gradient-to-r flex flex-col items-center from-blue-400 to-purple-600">
      <h2 className="text-3xl font-bold mb-4">Experience</h2>

      <div className="shadow bg-gradient-to-r p-8 from-blue-400 to-purple-600">
      <div className="mb-6 max-w-xl w-full">
        <h3 className="text-2xl font-semibold">React Developer</h3>
        <h4 className="text-lg font-medium">IBM, Mumbai</h4>
        <p className="text-gray-600">May 2024 - July 2024</p>
        <ul className="list-disc list-inside mt-2">
          <li>Integrated financial features including payment gateways (PayPal, UPI) into applications, enhancing user experience and functionality.</li>
          <li>Collaborated with cross-functional teams to design and implement a messaging center feature, improving user engagement.</li>
          <li>Utilized tools like Google Firebase for backend services and Postman for API testing, ensuring smooth application performance.</li>
        </ul>
      </div>

      <div className="mb-6 max-w-xl w-full">
        <h3 className="text-2xl font-semibold">React Native Developer</h3>
        <h4 className="text-lg font-medium">Girmiti Software Pvt Ltd, Bangalore</h4>
        <p className="text-gray-600">February 2022 - December 2023</p>
        <ul className="list-disc list-inside mt-2">
          <li>Developed and deployed 16 mobile applications on Google Play Store and App Store using React Native, leveraging a single code base for multiple apps.</li>
          <li>Implemented key functionalities using Redux and REST APIs to ensure data management and synchronization across applications.</li>
          <li>Participated in code reviews and maintained documentation to enhance team collaboration and code quality.</li>
        </ul>
      </div>

      <div className="mb-6 max-w-xl w-full">
        <h3 className="text-2xl font-semibold">Intern</h3>
        <h4 className="text-lg font-medium">Girmiti Software Pvt Ltd, Bangalore</h4>
        <p className="text-gray-600">September 2021 - February 2022</p>
        <ul className="list-disc list-inside mt-2">
          <li>Assisted in the development of web applications using HTML, CSS, and JavaScript.</li>
          <li>Gained exposure to the software development lifecycle and agile methodologies.</li>
        </ul>
      </div>
      </div>
    </section>
  );
}

export default Experience;
